import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
export function createTrackConfig() {
  return {
    // @ts-ignore
    poizon_trade_page_share(platform: any, { poizon_channel_id }: any) {
      // 不是会场页面不会触发埋点
      if (this.props.type !== 'dynamic') return
      return {
        current_page: 82,
        content_id: this.props.editConfig.id,
        content_url: window.location.href,
        content_title: document.title,
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
    poizon_venue_activity_pageview() {
      // 不是会场页面不会触发埋点
      if (this.props.type !== 'dynamic') return

      return {
        current_page: 82,
        venue_id: this.props.editConfig.id,
        venue_title: document.title,
        poizon_channel_id,
        SK: window.dw.getSk(),
      }
    },
  }
}
